<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="0" >東西就在第五個圓形窗戶裡！</npc>
              <npc :npc-id="1" right>我知道了，交給我吧！</npc>

              <story-image :src="require(`@/assets/images/pics/第8章_1-1_高賓閣正面.jpg`)"></story-image>
              <!-- （圖片：高賓閣正面圖) -->

              <npc :npc-id="1" right>窗邊放著這個東西！</npc>
              <npc :npc-id="0" >這是⋯⋯</npc>

              <story-image :src="require(`@/assets/images/pics/crystal.png`)" size="sm"></story-image>
              <!-- （圖片：神秘晶體） -->

              <npc :npc-id="1" right>這是什麼東西，是水晶嗎？</npc>
              <npc :npc-id="0" >不清楚，不過——</npc>
              <npc :npc-id="0" >林先生，接著！</npc>
              <npc :npc-id="4" right>多謝！</npc>
              <npc :npc-id="3" right>什麼！</npc>

              <move-to-stage-btn link="使用神秘晶體">使用神秘晶體</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage8_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第八章 - 1',
      isQuestion: false,
      stageId: 'crystal',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
